import { render, staticRenderFns } from "./drawerBack.vue?vue&type=template&id=446c2b28&"
import script from "./drawerBack.vue?vue&type=script&lang=js&"
export * from "./drawerBack.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports